import {
  containsSensitiveText,
  createFallback,
  isHighRiskText,
  safetyResult,
  type ExpressionTopic,
  type RefinementResult,
} from "../shared/refinement";

export async function refineExpression(
  topic: ExpressionTopic,
  input: string,
  privacyMode: boolean,
): Promise<RefinementResult> {
  if (isHighRiskText(input)) return safetyResult();
  if (containsSensitiveText(input)) {
    throw new Error("文字中可能含有联系方式、地址或账号，请删去后再试。");
  }
  if (privacyMode) return createFallback(topic, input);

  try {
    const response = await fetch("/api/refine", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ topic, input }),
    });
    if (!response.ok) {
      if (response.status === 400 || response.status === 422) {
        const data = (await response.json()) as { error?: string };
        throw new Error(data.error || "请检查输入后再试。");
      }
      return createFallback(topic, input);
    }
    const data = (await response.json()) as RefinementResult;
    return data as RefinementResult;
  } catch (error) {
    if (error instanceof Error && (error.message.includes("联系方式") || error.message.includes("检查输入"))) {
      throw error;
    }
    return createFallback(topic, input);
  }
}
